/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (bipro-partner::Bankverbindung)
 */
export interface BankDetails {
  /**
   * IBAN
   */
  IBAN?: string;
  /**
   * Reference to an existing IBAN entry of the partner.   For Verti internal usage only.
   */
  IBANRef?: string;
  /**
   * (german: SEPA Lastschriftmandat erteilt)
   */
  debitAuthorization?: boolean;
}
